import "@dxos/node-std/globals";
import "../../chunk-QCWEHHJW.mjs";

// src/packlets/locks/browser.ts
import { Trigger, asyncTimeout } from "@dxos/async";
import { RESOURCE_LOCK_TIMEOUT } from "@dxos/client-protocol";
import { log, logInfo } from "@dxos/log";
var __dxlog_file = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/locks/browser.ts";
function _ts_decorate(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
var Lock = class {
  _broadcastChannel = new BroadcastChannel("vault-resource-lock");
  _lockKey;
  _onAcquire;
  _onRelease;
  _releaseTrigger = new Trigger();
  constructor({ lockKey, onAcquire, onRelease }) {
    this._lockKey = lockKey;
    this._onAcquire = onAcquire;
    this._onRelease = onRelease;
    this._broadcastChannel.onmessage = this._onMessage.bind(this);
  }
  get lockKey() {
    return this._lockKey;
  }
  async acquire() {
    this._broadcastChannel.postMessage({
      message: "acquiring"
    });
    try {
      log("aquiring lock...", void 0, { "~LogMeta": "~LogMeta", F: __dxlog_file, L: 39, S: this });
      await asyncTimeout(this._requestLock(), RESOURCE_LOCK_TIMEOUT);
      log("acquired lock", void 0, { "~LogMeta": "~LogMeta", F: __dxlog_file, L: 41, S: this });
    } catch {
      log("stealing lock...", void 0, { "~LogMeta": "~LogMeta", F: __dxlog_file, L: 43, S: this });
      await this._requestLock(true);
      log("stolen lock", void 0, { "~LogMeta": "~LogMeta", F: __dxlog_file, L: 45, S: this });
    }
  }
  async release() {
    this._releaseTrigger.wake();
  }
  _onMessage(event) {
    if (event.data.message === "acquiring") {
      this._releaseTrigger.wake();
    }
  }
  async _requestLock(steal = false) {
    log("requesting lock...", {
      steal
    }, { "~LogMeta": "~LogMeta", F: __dxlog_file, L: 57, S: this });
    const acquired = new Trigger();
    void navigator.locks.request(this._lockKey, {
      steal
    }, async () => {
      await this._onAcquire?.();
      acquired.wake();
      this._releaseTrigger = new Trigger();
      await this._releaseTrigger.wait();
      log("releasing lock...", void 0, { "~LogMeta": "~LogMeta", F: __dxlog_file, L: 68, S: this });
      await this._onRelease?.();
      log("released lock", void 0, { "~LogMeta": "~LogMeta", F: __dxlog_file, L: 70, S: this });
    }).catch(async () => {
      await this._onRelease?.();
    });
    await acquired.wait();
    log("recieved lock", {
      steal
    }, { "~LogMeta": "~LogMeta", F: __dxlog_file, L: 75, S: this });
  }
};
_ts_decorate([
  logInfo
], Lock.prototype, "lockKey", null);
var isLocked = (lockPath) => {
  throw new Error("Not implemented");
};
export {
  Lock,
  isLocked
};
//# sourceMappingURL=browser.mjs.map
